import { BulkResizeDownloadState } from "../types";

export const reset = (state: BulkResizeDownloadState) => {
    state.downloadUrl = "";
    state.isExporting = false;
    state.isProcessing = true;
    state.jobs = [];
};
